/**
 * ============================================================
 * 日本語
 * ============================================================
 *
 * Translators:
 *
 *
 */

export default {
	'AdvanceHelp': 'ゲームを進めるためには、スペースキーを押すかクリックします',
	'AllowPlayback': 'オーディオ再生を許可するにはここをクリック',
	'Audio': 'オーディオ',
	'AutoPlay': 'オート',
	'AutoPlayButton': 'Enable auto play',
	'AutoPlaySpeed': 'オート再生速度',

	'Back': '巻き戻し',
	'BackButton': '巻き戻し',

	'Cancel': 'キャンセル',
	'Close': '閉めて',
	'Confirm': 'ゲームをやめたいと思いますか？',
	'Credits': 'Credits',

	'Delete': 'デリート',
	'DialogLogButton': 'ダイアログログの表示',

	'FullScreen': '全画面表示',

	'Gallery': 'Gallery',

	'Help': 'ヘルプ',
	'Hide': '「非表示」',
	'HideButton': 'テキストを隠します',

	'iOSAudioWarning': 'iOSではオーディオ設定がサポートされていません',

	'KeyboardShortcuts': 'Keyboard Shortcuts',

	'Language': '言語',
	'Load': 'ロード',
	'LoadAutoSaveSlots': '自動的に保存されたゲーム',
	'LoadButton': 'ロード画面を開きます',
	'Loading': '読み込み中',
	'LoadingMessage': 'ファイルがロードされるのを待ちます',
	'LoadSlots': '保存されたゲーム',
	'LocalStorageWarning': 'このブラウザではローカルストレージは使用できません',
	'Log': 'Log',

	'Music': '音楽の音量',

	'NextButton': '次のダイアログに移動',
	'NewContent': 'There is new content available, reload the page to get the latest version',
	'NoSavedGames': '保存されたゲームはありません',
	'NoAutoSavedGames': '自動的に保存されたゲームはありません',
	'NoDialogsAvailable': 'No dialogs available. Dialogs will appear here as they show up',

	'OK': 'OK',
	'OrientationWarning': '再生するには端末を回転させてください',
	'Overwrite': '上書き',

	'QuickButtons': 'クイックメニューボタン',
	'QuickMenu': 'Quick Menu',
	'Quit': '終了する',
	'QuitButton': 'ゲームを終了します',

	'Resolution': '解像度',

	'Save': 'セーブ',
	'SaveButton': '保存画面を開きます',
	'SaveInSlot': 'スロットにセーブする',
	'SelectYourLanguage': '言語の選択',
	'Settings': '設定',
	'SettingsButton': '設定画面を開きます',
	'Show': 'ショー',
	'Skip': 'スキップ',
	'SkipButton': 'Enter skip mode',
	'SlotDeletion': '本当にこのスロットを削除しますか？',
	'SlotOverwrite': '本当にこのスロットを上書きしますか？',
	'Sound': '効果音の音量',
	'Start': 'スタート',
	'Stop': '停止',

	'TextSpeed': 'テキストスピード',

	'Video': 'ビデオボリューム',
	'Voice': 'ボイスの音量',

	'Windowed': '窓'
};